import React from "react";
import { Link } from "@mui/material";

// #99 - render a plain-text message with any email addresses turned into
// mailto links. Server error messages that tell the user to contact an
// address (signup refusals, cross-agency errors) stay copy-on-the-server;
// this makes the address clickable wherever the message is shown.
const EMAIL_RE = /([A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})/gi;

export default function linkifyEmails(text) {
  const s = String(text ?? "");
  const parts = s.split(EMAIL_RE);
  if (parts.length === 1) return s;
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <Link key={i} href={`mailto:${part}`}>
        {part}
      </Link>
    ) : (
      part
    )
  );
}
